import React from 'react';
import InputSquare from './InputSquare';

type SolutionInputProps = {
  guess: (string | null)[];
  clueIndex: number;
};

const SolutionInput = ({ guess, clueIndex }: SolutionInputProps) => {
  return (
    <div className="solutionInput">
      {guess.map((letter, letterIndex) => (
        <InputSquare key={letterIndex} clueIndex={clueIndex} letterIndex={letterIndex}/>
      ))}
    </div>
  );
};

export default SolutionInput;